import PropTypes from 'prop-types';
import Image from '@/components/Image';

const defaultProps = {
  sizes: null,
  srcSet: null,
  guid: null,
};

const propTypes = {
  sizes: PropTypes.string,
  srcSet: PropTypes.string,
  sourceUrl: PropTypes.string.isRequired,
  guid: PropTypes.string,
  alt: PropTypes.string.isRequired,
};

export default function FeaturedImage({ sourceUrl, alt, ...rest }) {
  return <Image src={sourceUrl} alt={alt} {...rest} />;
}

FeaturedImage.defaultProps = defaultProps;
FeaturedImage.propTypes = propTypes;
